export default __webpack_public_path__ + "static/media/app7-section3-image1.d22cf053.png";